<div class="textarea-block" [ngStyle]="styles">
  <label class="custom-textarea-label" for="textarea-custom">{{ label }}</label>
  <textarea
    class="custom-textarea"
    id="textarea-custom"
    [disabled]="disabled"
    >{{ value }}</textarea
  >
</div>
